export const METRIC_SET_CODE = `promise.then(() => {
    window.dundas.context.embedMetricSet(document.getElementById("container"), "%embedMetricSetId%", {
        "sessionId": '%sessionId%',
        "embeddedViewServiceName": "MetricSetEmbeddedViewService",
    });
});
`;
